// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-card__input {
  width: 70%;
}

.user-card__productivity-field {
  width: 70%;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.user-card__productivity-field .user-card__input--productivity-inner {
  flex: 1 1;
  min-width: 0;
  width: 100% !important;
  max-width: none;
}

.user-card__input input {
  width: 100%;
}

.user-card__input-employee {
  width: 310px;
}

.employee-card-errors {
  max-width: 284px;
  margin: 0;
  font-size: 12px;
}

.employee-card-errors.password-errors {
  height: 48px;
  position: relative;
  top: -44px;
}

.password {
  height: 58px;
}
.emploee-card__column {
  width: 50%;
}
.employee-card .p-tabview-panels .show-password-button {
  position: relative;
  align-self: flex-end;
  bottom: 42px;
}

.error-tab .p-tabview-title {
  color: red;
}

.employee-card .password .p-button.p-button-icon-only {
  padding: 0.8rem;
}

.employee-card-errors-password {
  top: -16px;
  position: relative;
}

.employee-personSchedules {
  width: 650px;
}

.employee-personSchedules__add,
.employee-personAttainments__add {
  margin-right: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/EmployeeCard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;AACpB","sourcesContent":[".user-card__input {\n  width: 70%;\n}\n\n.user-card__productivity-field {\n  width: 70%;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.user-card__productivity-field .user-card__input--productivity-inner {\n  flex: 1 1 0;\n  min-width: 0;\n  width: 100% !important;\n  max-width: none;\n}\n\n.user-card__input input {\n  width: 100%;\n}\n\n.user-card__input-employee {\n  width: 310px;\n}\n\n.employee-card-errors {\n  max-width: 284px;\n  margin: 0;\n  font-size: 12px;\n}\n\n.employee-card-errors.password-errors {\n  height: 48px;\n  position: relative;\n  top: -44px;\n}\n\n.password {\n  height: 58px;\n}\n.emploee-card__column {\n  width: 50%;\n}\n.employee-card .p-tabview-panels .show-password-button {\n  position: relative;\n  align-self: flex-end;\n  bottom: 42px;\n}\n\n.error-tab .p-tabview-title {\n  color: red;\n}\n\n.employee-card .password .p-button.p-button-icon-only {\n  padding: 0.8rem;\n}\n\n.employee-card-errors-password {\n  top: -16px;\n  position: relative;\n}\n\n.employee-personSchedules {\n  width: 650px;\n}\n\n.employee-personSchedules__add,\n.employee-personAttainments__add {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
